/**
 * Phone number formatting and validation utilities
 */

export interface CountryCode {
  code: string;
  name: string;
  flag: string;
  format: string;
  example: string;
  maxLength: number;
}

export const COUNTRY_CODES: CountryCode[] = [
  {
    code: "+39",
    name: "Italy",
    flag: "🇮🇹",
    format: "XXX XXX XXXX",
    example: "312 345 6789",
    maxLength: 13
  },
  {
    code: "+93",
    name: "Afghanistan",
    flag: "🇦🇫",
    format: "XX XXX XXXX",
    example: "70 123 4567",
    maxLength: 12
  },
  {
    code: "+355",
    name: "Albania",
    flag: "🇦🇱",
    format: "XX XXX XXXX",
    example: "67 123 4567",
    maxLength: 12
  },
  {
    code: "+213",
    name: "Algeria",
    flag: "🇩🇿",
    format: "XXX XX XX XX",
    example: "551 23 45 67",
    maxLength: 13
  },
  {
    code: "+376",
    name: "Andorra",
    flag: "🇦🇩",
    format: "XXX XXX",
    example: "312 345",
    maxLength: 9
  },
  {
    code: "+244",
    name: "Angola",
    flag: "🇦🇴",
    format: "XXX XXX XXX",
    example: "923 123 456",
    maxLength: 12
  },
  {
    code: "+54",
    name: "Argentina",
    flag: "🇦🇷",
    format: "XX XXXX XXXX",
    example: "11 1234 5678",
    maxLength: 13
  },
  {
    code: "+374",
    name: "Armenia",
    flag: "🇦🇲",
    format: "XX XXX XXX",
    example: "77 123 456",
    maxLength: 11
  },
  {
    code: "+61",
    name: "Australia",
    flag: "🇦🇺",
    format: "XXX XXX XXX",
    example: "412 345 678",
    maxLength: 12
  },
  {
    code: "+43",
    name: "Austria",
    flag: "🇦🇹",
    format: "XXX XXXXXXX",
    example: "664 1234567",
    maxLength: 13
  },
  {
    code: "+994",
    name: "Azerbaijan",
    flag: "🇦🇿",
    format: "XX XXX XX XX",
    example: "50 123 45 67",
    maxLength: 13
  },
  {
    code: "+973",
    name: "Bahrain",
    flag: "🇧🇭",
    format: "XXXX XXXX",
    example: "3612 3456",
    maxLength: 11
  },
  {
    code: "+880",
    name: "Bangladesh",
    flag: "🇧🇩",
    format: "XXXX XXXXXX",
    example: "1812 345678",
    maxLength: 14
  },
  {
    code: "+375",
    name: "Belarus",
    flag: "🇧🇾",
    format: "XX XXX XXXX",
    example: "29 123 4567",
    maxLength: 12
  },
  {
    code: "+32",
    name: "Belgium",
    flag: "🇧🇪",
    format: "XXX XX XX XX",
    example: "470 12 34 56",
    maxLength: 12
  },
  {
    code: "+501",
    name: "Belize",
    flag: "🇧🇿",
    format: "XXX XXXX",
    example: "622 1234",
    maxLength: 10
  },
  {
    code: "+229",
    name: "Benin",
    flag: "🇧🇯",
    format: "XX XX XX XX",
    example: "90 12 34 56",
    maxLength: 11
  },
  {
    code: "+975",
    name: "Bhutan",
    flag: "🇧🇹",
    format: "XX XXX XXX",
    example: "17 123 456",
    maxLength: 11
  },
  {
    code: "+591",
    name: "Bolivia",
    flag: "🇧🇴",
    format: "X XXX XXXX",
    example: "7 123 4567",
    maxLength: 11
  },
  {
    code: "+387",
    name: "Bosnia and Herzegovina",
    flag: "🇧🇦",
    format: "XX XXX XXX",
    example: "61 123 456",
    maxLength: 11
  },
  {
    code: "+267",
    name: "Botswana",
    flag: "🇧🇼",
    format: "XX XXX XXX",
    example: "71 123 456",
    maxLength: 11
  },
  {
    code: "+55",
    name: "Brazil",
    flag: "🇧🇷",
    format: "XX XXXXX XXXX",
    example: "11 91234 5678",
    maxLength: 14
  },
  {
    code: "+673",
    name: "Brunei",
    flag: "🇧🇳",
    format: "XXX XXXX",
    example: "712 3456",
    maxLength: 10
  },
  {
    code: "+359",
    name: "Bulgaria",
    flag: "🇧🇬",
    format: "XX XXX XXXX",
    example: "87 123 4567",
    maxLength: 12
  },
  {
    code: "+226",
    name: "Burkina Faso",
    flag: "🇧🇫",
    format: "XX XX XX XX",
    example: "70 12 34 56",
    maxLength: 11
  },
  {
    code: "+257",
    name: "Burundi",
    flag: "🇧🇮",
    format: "XX XX XX XX",
    example: "79 12 34 56",
    maxLength: 11
  },
  {
    code: "+855",
    name: "Cambodia",
    flag: "🇰🇭",
    format: "XX XXX XXXX",
    example: "91 234 5678",
    maxLength: 12
  },
  {
    code: "+237",
    name: "Cameroon",
    flag: "🇨🇲",
    format: "X XX XX XX XX",
    example: "6 12 34 56 78",
    maxLength: 13
  },
  {
    code: "+1",
    name: "Canada",
    flag: "🇨🇦",
    format: "(XXX) XXX-XXXX",
    example: "(555) 123-4567",
    maxLength: 14
  },
  {
    code: "+238",
    name: "Cape Verde",
    flag: "🇨🇻",
    format: "XXX XXXX",
    example: "991 2345",
    maxLength: 10
  },
  {
    code: "+236",
    name: "Central African Republic",
    flag: "🇨🇫",
    format: "XX XX XX XX",
    example: "70 12 34 56",
    maxLength: 11
  },
  {
    code: "+235",
    name: "Chad",
    flag: "🇹🇩",
    format: "XX XX XX XX",
    example: "63 12 34 56",
    maxLength: 11
  },
  {
    code: "+56",
    name: "Chile",
    flag: "🇨🇱",
    format: "X XXXX XXXX",
    example: "9 1234 5678",
    maxLength: 12
  },
  {
    code: "+86",
    name: "China",
    flag: "🇨🇳",
    format: "XXX XXXX XXXX",
    example: "138 0013 8000",
    maxLength: 14
  },
  {
    code: "+57",
    name: "Colombia",
    flag: "🇨🇴",
    format: "XXX XXX XXXX",
    example: "300 123 4567",
    maxLength: 13
  },
  {
    code: "+269",
    name: "Comoros",
    flag: "🇰🇲",
    format: "XXX XXXX",
    example: "321 2345",
    maxLength: 10
  },
  {
    code: "+242",
    name: "Republic of the Congo",
    flag: "🇨🇬",
    format: "XX XXX XXXX",
    example: "06 123 4567",
    maxLength: 12
  },
  {
    code: "+243",
    name: "Democratic Republic of the Congo",
    flag: "🇨🇩",
    format: "XXX XXX XXX",
    example: "991 234 567",
    maxLength: 12
  },
  {
    code: "+506",
    name: "Costa Rica",
    flag: "🇨🇷",
    format: "XXXX XXXX",
    example: "8312 3456",
    maxLength: 11
  },
  {
    code: "+225",
    name: "Côte d'Ivoire",
    flag: "🇨🇮",
    format: "XX XX XX XX XX",
    example: "01 23 45 67 89",
    maxLength: 13
  },
  {
    code: "+385",
    name: "Croatia",
    flag: "🇭🇷",
    format: "XX XXX XXXX",
    example: "91 234 5678",
    maxLength: 12
  },
  {
    code: "+53",
    name: "Cuba",
    flag: "🇨🇺",
    format: "X XXX XXXX",
    example: "5 123 4567",
    maxLength: 11
  },
  {
    code: "+357",
    name: "Cyprus",
    flag: "🇨🇾",
    format: "XX XXX XXX",
    example: "96 123 456",
    maxLength: 11
  },
  {
    code: "+420",
    name: "Czech Republic",
    flag: "🇨🇿",
    format: "XXX XXX XXX",
    example: "601 123 456",
    maxLength: 12
  },
  {
    code: "+45",
    name: "Denmark",
    flag: "🇩🇰",
    format: "XX XX XX XX",
    example: "20 12 34 56",
    maxLength: 11
  },
  {
    code: "+253",
    name: "Djibouti",
    flag: "🇩🇯",
    format: "XX XX XX XX",
    example: "77 12 34 56",
    maxLength: 11
  },
  {
    code: "+1767",
    name: "Dominica",
    flag: "🇩🇲",
    format: "XXX XXXX",
    example: "767 2345",
    maxLength: 10
  },
  {
    code: "+1809",
    name: "Dominican Republic",
    flag: "🇩🇴",
    format: "XXX XXX XXXX",
    example: "809 234 5678",
    maxLength: 13
  },
  {
    code: "+593",
    name: "Ecuador",
    flag: "🇪🇨",
    format: "XX XXX XXXX",
    example: "99 123 4567",
    maxLength: 12
  },
  {
    code: "+20",
    name: "Egypt",
    flag: "🇪🇬",
    format: "XXX XXX XXXX",
    example: "100 123 4567",
    maxLength: 13
  },
  {
    code: "+503",
    name: "El Salvador",
    flag: "🇸🇻",
    format: "XXXX XXXX",
    example: "7012 3456",
    maxLength: 11
  },
  {
    code: "+240",
    name: "Equatorial Guinea",
    flag: "🇬🇶",
    format: "XXX XXX XXX",
    example: "222 123 456",
    maxLength: 12
  },
  {
    code: "+291",
    name: "Eritrea",
    flag: "🇪🇷",
    format: "X XXX XXX",
    example: "7 123 456",
    maxLength: 10
  },
  {
    code: "+372",
    name: "Estonia",
    flag: "🇪🇪",
    format: "XXXX XXXX",
    example: "5123 4567",
    maxLength: 11
  },
  {
    code: "+268",
    name: "Eswatini",
    flag: "🇸🇿",
    format: "XX XX XX XX",
    example: "76 12 34 56",
    maxLength: 11
  },
  {
    code: "+251",
    name: "Ethiopia",
    flag: "🇪🇹",
    format: "XX XXX XXXX",
    example: "91 123 4567",
    maxLength: 12
  },
  {
    code: "+679",
    name: "Fiji",
    flag: "🇫🇯",
    format: "XXX XXXX",
    example: "701 2345",
    maxLength: 10
  },
  {
    code: "+358",
    name: "Finland",
    flag: "🇫🇮",
    format: "XX XXX XXXX",
    example: "50 123 4567",
    maxLength: 12
  },
  {
    code: "+33",
    name: "France",
    flag: "🇫🇷",
    format: "X XX XX XX XX",
    example: "6 12 34 56 78",
    maxLength: 14
  },
  {
    code: "+241",
    name: "Gabon",
    flag: "🇬🇦",
    format: "X XX XX XX",
    example: "6 12 34 56",
    maxLength: 11
  },
  {
    code: "+220",
    name: "Gambia",
    flag: "🇬🇲",
    format: "XXX XXXX",
    example: "301 2345",
    maxLength: 10
  },
  {
    code: "+995",
    name: "Georgia",
    flag: "🇬🇪",
    format: "XXX XXX XXX",
    example: "577 123 456",
    maxLength: 12
  },
  {
    code: "+49",
    name: "Germany",
    flag: "🇩🇪",
    format: "XXX XXXXXXX",
    example: "151 1234567",
    maxLength: 12
  },
  {
    code: "+233",
    name: "Ghana",
    flag: "🇬🇭",
    format: "XX XXX XXXX",
    example: "23 123 4567",
    maxLength: 12
  },
  {
    code: "+30",
    name: "Greece",
    flag: "🇬🇷",
    format: "XXX XXX XXXX",
    example: "691 234 5678",
    maxLength: 13
  },
  {
    code: "+1473",
    name: "Grenada",
    flag: "🇬🇩",
    format: "XXX XXXX",
    example: "473 2345",
    maxLength: 10
  },
  {
    code: "+502",
    name: "Guatemala",
    flag: "🇬🇹",
    format: "XXXX XXXX",
    example: "5123 4567",
    maxLength: 11
  },
  {
    code: "+224",
    name: "Guinea",
    flag: "🇬🇳",
    format: "XXX XXX XXX",
    example: "601 123 456",
    maxLength: 12
  },
  {
    code: "+245",
    name: "Guinea-Bissau",
    flag: "🇬🇼",
    format: "XXX XXXX",
    example: "955 1234",
    maxLength: 10
  },
  {
    code: "+592",
    name: "Guyana",
    flag: "🇬🇾",
    format: "XXX XXXX",
    example: "609 1234",
    maxLength: 10
  },
  {
    code: "+509",
    name: "Haiti",
    flag: "🇭🇹",
    format: "XX XX XXXX",
    example: "34 12 3456",
    maxLength: 11
  },
  {
    code: "+504",
    name: "Honduras",
    flag: "🇭🇳",
    format: "XXXX XXXX",
    example: "9123 4567",
    maxLength: 11
  },
  {
    code: "+36",
    name: "Hungary",
    flag: "🇭🇺",
    format: "XX XXX XXXX",
    example: "20 123 4567",
    maxLength: 12
  },
  {
    code: "+354",
    name: "Iceland",
    flag: "🇮🇸",
    format: "XXX XXXX",
    example: "611 2345",
    maxLength: 10
  },
  {
    code: "+91",
    name: "India",
    flag: "🇮🇳",
    format: "XXXXX XXXXX",
    example: "81234 56789",
    maxLength: 13
  },
  {
    code: "+62",
    name: "Indonesia",
    flag: "🇮🇩",
    format: "XXX XXXX XXXX",
    example: "812 3456 7890",
    maxLength: 14
  },
  {
    code: "+98",
    name: "Iran",
    flag: "🇮🇷",
    format: "XXX XXX XXXX",
    example: "901 234 5678",
    maxLength: 13
  },
  {
    code: "+964",
    name: "Iraq",
    flag: "🇮🇶",
    format: "XXX XXX XXXX",
    example: "790 123 4567",
    maxLength: 13
  },
  {
    code: "+353",
    name: "Ireland",
    flag: "🇮🇪",
    format: "XX XXX XXXX",
    example: "85 123 4567",
    maxLength: 12
  },
  {
    code: "+972",
    name: "Israel",
    flag: "🇮🇱",
    format: "XX XXX XXXX",
    example: "50 123 4567",
    maxLength: 12
  },
  {
    code: "+81",
    name: "Japan",
    flag: "🇯🇵",
    format: "XXX XXXX XXXX",
    example: "090 1234 5678",
    maxLength: 14
  },
  {
    code: "+962",
    name: "Jordan",
    flag: "🇯🇴",
    format: "X XXXX XXXX",
    example: "7 9012 3456",
    maxLength: 12
  },
  {
    code: "+7",
    name: "Kazakhstan",
    flag: "🇰🇿",
    format: "XXX XXX XXXX",
    example: "701 234 5678",
    maxLength: 13
  },
  {
    code: "+254",
    name: "Kenya",
    flag: "🇰🇪",
    format: "XXX XXX XXX",
    example: "712 345 678",
    maxLength: 12
  },
  {
    code: "+686",
    name: "Kiribati",
    flag: "🇰🇮",
    format: "XX XXX",
    example: "72 123",
    maxLength: 8
  },
  {
    code: "+965",
    name: "Kuwait",
    flag: "🇰🇼",
    format: "XXXX XXXX",
    example: "5012 3456",
    maxLength: 11
  },
  {
    code: "+996",
    name: "Kyrgyzstan",
    flag: "🇰🇬",
    format: "XXX XXX XXX",
    example: "700 123 456",
    maxLength: 12
  },
  {
    code: "+856",
    name: "Laos",
    flag: "🇱🇦",
    format: "XX XX XXX XXX",
    example: "20 55 123 456",
    maxLength: 13
  },
  {
    code: "+371",
    name: "Latvia",
    flag: "🇱🇻",
    format: "XX XXX XXX",
    example: "21 234 567",
    maxLength: 11
  },
  {
    code: "+961",
    name: "Lebanon",
    flag: "🇱🇧",
    format: "XX XXX XXX",
    example: "71 123 456",
    maxLength: 11
  },
  {
    code: "+266",
    name: "Lesotho",
    flag: "🇱🇸",
    format: "X XXX XXXX",
    example: "5 012 3456",
    maxLength: 11
  },
  {
    code: "+231",
    name: "Liberia",
    flag: "🇱🇷",
    format: "XX XXX XXXX",
    example: "77 012 3456",
    maxLength: 12
  },
  {
    code: "+218",
    name: "Libya",
    flag: "🇱🇾",
    format: "XX XXX XXXX",
    example: "91 234 5678",
    maxLength: 12
  },
  {
    code: "+423",
    name: "Liechtenstein",
    flag: "🇱🇮",
    format: "XXX XX XX",
    example: "660 12 34",
    maxLength: 11
  },
  {
    code: "+370",
    name: "Lithuania",
    flag: "🇱🇹",
    format: "XXX XXXXX",
    example: "612 34567",
    maxLength: 11
  },
  {
    code: "+352",
    name: "Luxembourg",
    flag: "🇱🇺",
    format: "XXX XXX XXX",
    example: "628 123 456",
    maxLength: 12
  },
  {
    code: "+261",
    name: "Madagascar",
    flag: "🇲🇬",
    format: "XX XX XXX XX",
    example: "32 12 345 67",
    maxLength: 13
  },
  {
    code: "+265",
    name: "Malawi",
    flag: "🇲🇼",
    format: "X XXX XXXX",
    example: "9 912 3456",
    maxLength: 11
  },
  {
    code: "+60",
    name: "Malaysia",
    flag: "🇲🇾",
    format: "XX XXXX XXXX",
    example: "12 3456 7890",
    maxLength: 12
  },
  {
    code: "+960",
    name: "Maldives",
    flag: "🇲🇻",
    format: "XXX XXXX",
    example: "771 2345",
    maxLength: 10
  },
  {
    code: "+223",
    name: "Mali",
    flag: "🇲🇱",
    format: "XX XX XX XX",
    example: "65 12 34 56",
    maxLength: 11
  },
  {
    code: "+356",
    name: "Malta",
    flag: "🇲🇹",
    format: "XXXX XXXX",
    example: "9696 1234",
    maxLength: 11
  },
  {
    code: "+692",
    name: "Marshall Islands",
    flag: "🇲🇭",
    format: "XXX XXXX",
    example: "235 1234",
    maxLength: 10
  },
  {
    code: "+222",
    name: "Mauritania",
    flag: "🇲🇷",
    format: "XX XX XX XX",
    example: "22 12 34 56",
    maxLength: 11
  },
  {
    code: "+230",
    name: "Mauritius",
    flag: "🇲🇺",
    format: "XXXX XXXX",
    example: "5251 2345",
    maxLength: 11
  },
  {
    code: "+52",
    name: "Mexico",
    flag: "🇲🇽",
    format: "XXX XXX XXXX",
    example: "044 555 1234",
    maxLength: 13
  },
  {
    code: "+691",
    name: "Micronesia",
    flag: "🇫🇲",
    format: "XXX XXXX",
    example: "350 1234",
    maxLength: 10
  },
  {
    code: "+373",
    name: "Moldova",
    flag: "🇲🇩",
    format: "XX XXX XXX",
    example: "69 123 456",
    maxLength: 11
  },
  {
    code: "+377",
    name: "Monaco",
    flag: "🇲🇨",
    format: "XX XX XX XX",
    example: "06 12 34 56",
    maxLength: 11
  },
  {
    code: "+976",
    name: "Mongolia",
    flag: "🇲🇳",
    format: "XXXX XXXX",
    example: "8812 3456",
    maxLength: 11
  },
  {
    code: "+382",
    name: "Montenegro",
    flag: "🇲🇪",
    format: "XX XXX XXX",
    example: "67 123 456",
    maxLength: 11
  },
  {
    code: "+212",
    name: "Morocco",
    flag: "🇲🇦",
    format: "XXX XXXXXX",
    example: "650 123456",
    maxLength: 12
  },
  {
    code: "+258",
    name: "Mozambique",
    flag: "🇲🇿",
    format: "XX XXX XXXX",
    example: "82 123 4567",
    maxLength: 12
  },
  {
    code: "+95",
    name: "Myanmar",
    flag: "🇲🇲",
    format: "XX XXX XXXX",
    example: "09 123 4567",
    maxLength: 12
  },
  {
    code: "+264",
    name: "Namibia",
    flag: "🇳🇦",
    format: "XX XXX XXXX",
    example: "81 123 4567",
    maxLength: 12
  },
  {
    code: "+674",
    name: "Nauru",
    flag: "🇳🇷",
    format: "XXX XXXX",
    example: "555 1234",
    maxLength: 10
  },
  {
    code: "+977",
    name: "Nepal",
    flag: "🇳🇵",
    format: "XXX XXX XXXX",
    example: "984 123 4567",
    maxLength: 13
  },
  {
    code: "+31",
    name: "Netherlands",
    flag: "🇳🇱",
    format: "X XX XX XX XX",
    example: "6 12 34 56 78",
    maxLength: 13
  },
  {
    code: "+64",
    name: "New Zealand",
    flag: "🇳🇿",
    format: "XX XXX XXXX",
    example: "21 123 4567",
    maxLength: 12
  },
  {
    code: "+505",
    name: "Nicaragua",
    flag: "🇳🇮",
    format: "XXXX XXXX",
    example: "8123 4567",
    maxLength: 11
  },
  {
    code: "+227",
    name: "Niger",
    flag: "🇳🇪",
    format: "XX XX XX XX",
    example: "93 12 34 56",
    maxLength: 11
  },
  {
    code: "+234",
    name: "Nigeria",
    flag: "🇳🇬",
    format: "XXX XXX XXXX",
    example: "802 123 4567",
    maxLength: 13
  },
  {
    code: "+850",
    name: "North Korea",
    flag: "🇰🇵",
    format: "XXX XXXX XXXX",
    example: "191 1234 5678",
    maxLength: 14
  },
  {
    code: "+389",
    name: "North Macedonia",
    flag: "🇲🇰",
    format: "XX XXX XXX",
    example: "70 123 456",
    maxLength: 11
  },
  {
    code: "+47",
    name: "Norway",
    flag: "🇳🇴",
    format: "XXX XX XXX",
    example: "406 12 345",
    maxLength: 11
  },
  {
    code: "+968",
    name: "Oman",
    flag: "🇴🇲",
    format: "XXXX XXXX",
    example: "9212 3456",
    maxLength: 11
  },
  {
    code: "+92",
    name: "Pakistan",
    flag: "🇵🇰",
    format: "XXX XXX XXXX",
    example: "300 123 4567",
    maxLength: 13
  },
  {
    code: "+680",
    name: "Palau",
    flag: "🇵🇼",
    format: "XXX XXXX",
    example: "620 1234",
    maxLength: 10
  },
  {
    code: "+507",
    name: "Panama",
    flag: "🇵🇦",
    format: "XXXX XXXX",
    example: "6123 4567",
    maxLength: 11
  },
  {
    code: "+675",
    name: "Papua New Guinea",
    flag: "🇵🇬",
    format: "XXX XXXX",
    example: "681 2345",
    maxLength: 10
  },
  {
    code: "+595",
    name: "Paraguay",
    flag: "🇵🇾",
    format: "XXX XXX XXX",
    example: "961 123 456",
    maxLength: 12
  },
  {
    code: "+51",
    name: "Peru",
    flag: "🇵🇪",
    format: "XXX XXX XXX",
    example: "987 654 321",
    maxLength: 12
  },
  {
    code: "+63",
    name: "Philippines",
    flag: "🇵🇭",
    format: "XXX XXX XXXX",
    example: "917 123 4567",
    maxLength: 13
  },
  {
    code: "+48",
    name: "Poland",
    flag: "🇵🇱",
    format: "XXX XXX XXX",
    example: "512 345 678",
    maxLength: 12
  },
  {
    code: "+351",
    name: "Portugal",
    flag: "🇵🇹",
    format: "XXX XXX XXX",
    example: "912 345 678",
    maxLength: 12
  },
  {
    code: "+974",
    name: "Qatar",
    flag: "🇶🇦",
    format: "XXXX XXXX",
    example: "3312 3456",
    maxLength: 11
  },
  {
    code: "+40",
    name: "Romania",
    flag: "🇷🇴",
    format: "XXX XXX XXX",
    example: "712 345 678",
    maxLength: 12
  },
  {
    code: "+7",
    name: "Russia",
    flag: "🇷🇺",
    format: "XXX XXX XXXX",
    example: "901 234 5678",
    maxLength: 13
  },
  {
    code: "+250",
    name: "Rwanda",
    flag: "🇷🇼",
    format: "XXX XXX XXX",
    example: "788 123 456",
    maxLength: 12
  },
  {
    code: "+685",
    name: "Samoa",
    flag: "🇼🇸",
    format: "XX XXXX",
    example: "72 1234",
    maxLength: 9
  },
  {
    code: "+378",
    name: "San Marino",
    flag: "🇸🇲",
    format: "XXXX XXXXXX",
    example: "6619 123456",
    maxLength: 13
  },
  {
    code: "+239",
    name: "São Tomé and Príncipe",
    flag: "🇸🇹",
    format: "XXX XXXX",
    example: "981 2345",
    maxLength: 10
  },
  {
    code: "+966",
    name: "Saudi Arabia",
    flag: "🇸🇦",
    format: "XX XXX XXXX",
    example: "50 123 4567",
    maxLength: 12
  },
  {
    code: "+221",
    name: "Senegal",
    flag: "🇸🇳",
    format: "XX XXX XX XX",
    example: "77 123 45 67",
    maxLength: 12
  },
  {
    code: "+381",
    name: "Serbia",
    flag: "🇷🇸",
    format: "XX XXX XXXX",
    example: "60 123 4567",
    maxLength: 12
  },
  {
    code: "+248",
    name: "Seychelles",
    flag: "🇸🇨",
    format: "X XX XX XX",
    example: "2 51 23 45",
    maxLength: 10
  },
  {
    code: "+232",
    name: "Sierra Leone",
    flag: "🇸🇱",
    format: "XX XXX XXX",
    example: "25 123 456",
    maxLength: 11
  },
  {
    code: "+65",
    name: "Singapore",
    flag: "🇸🇬",
    format: "XXXX XXXX",
    example: "9123 4567",
    maxLength: 11
  },
  {
    code: "+421",
    name: "Slovakia",
    flag: "🇸🇰",
    format: "XXX XXX XXX",
    example: "905 123 456",
    maxLength: 12
  },
  {
    code: "+386",
    name: "Slovenia",
    flag: "🇸🇮",
    format: "XX XXX XXX",
    example: "31 123 456",
    maxLength: 11
  },
  {
    code: "+677",
    name: "Solomon Islands",
    flag: "🇸🇧",
    format: "XXX XXXX",
    example: "749 1234",
    maxLength: 10
  },
  {
    code: "+252",
    name: "Somalia",
    flag: "🇸🇴",
    format: "XX XXX XXX",
    example: "90 123 456",
    maxLength: 11
  },
  {
    code: "+27",
    name: "South Africa",
    flag: "🇿🇦",
    format: "XX XXX XXXX",
    example: "82 123 4567",
    maxLength: 12
  },
  {
    code: "+82",
    name: "South Korea",
    flag: "🇰🇷",
    format: "XXX XXXX XXXX",
    example: "010 1234 5678",
    maxLength: 14
  },
  {
    code: "+211",
    name: "South Sudan",
    flag: "🇸🇸",
    format: "XXX XXX XXX",
    example: "977 123 456",
    maxLength: 12
  },
  {
    code: "+34",
    name: "Spain",
    flag: "🇪🇸",
    format: "XXX XXX XXX",
    example: "612 345 678",
    maxLength: 12
  },
  {
    code: "+94",
    name: "Sri Lanka",
    flag: "🇱🇰",
    format: "XX XXX XXXX",
    example: "71 234 5678",
    maxLength: 12
  },
  {
    code: "+249",
    name: "Sudan",
    flag: "🇸🇩",
    format: "XXX XXX XXX",
    example: "912 345 678",
    maxLength: 12
  },
  {
    code: "+597",
    name: "Suriname",
    flag: "🇸🇷",
    format: "XXX XXXX",
    example: "741 2345",
    maxLength: 10
  },
  {
    code: "+46",
    name: "Sweden",
    flag: "🇸🇪",
    format: "XXX XXX XX XX",
    example: "070 123 45 67",
    maxLength: 13
  },
  {
    code: "+41",
    name: "Switzerland",
    flag: "🇨🇭",
    format: "XX XXX XX XX",
    example: "78 123 45 67",
    maxLength: 12
  },
  {
    code: "+963",
    name: "Syria",
    flag: "🇸🇾",
    format: "XXX XXX XXX",
    example: "944 567 890",
    maxLength: 12
  },
  {
    code: "+886",
    name: "Taiwan",
    flag: "🇹🇼",
    format: "XXX XXX XXX",
    example: "912 345 678",
    maxLength: 12
  },
  {
    code: "+992",
    name: "Tajikistan",
    flag: "🇹🇯",
    format: "XX XXX XXXX",
    example: "90 123 4567",
    maxLength: 12
  },
  {
    code: "+255",
    name: "Tanzania",
    flag: "🇹🇿",
    format: "XXX XXX XXX",
    example: "754 123 456",
    maxLength: 12
  },
  {
    code: "+66",
    name: "Thailand",
    flag: "🇹🇭",
    format: "XX XXX XXXX",
    example: "81 234 5678",
    maxLength: 12
  },
  {
    code: "+670",
    name: "Timor-Leste",
    flag: "🇹🇱",
    format: "XXX XXXX",
    example: "771 2345",
    maxLength: 10
  },
  {
    code: "+228",
    name: "Togo",
    flag: "🇹🇬",
    format: "XX XX XX XX",
    example: "90 12 34 56",
    maxLength: 11
  },
  {
    code: "+676",
    name: "Tonga",
    flag: "🇹🇴",
    format: "XXX XXXX",
    example: "771 5123",
    maxLength: 10
  },
  {
    code: "+1868",
    name: "Trinidad and Tobago",
    flag: "🇹🇹",
    format: "XXX XXXX",
    example: "868 2345",
    maxLength: 10
  },
  {
    code: "+216",
    name: "Tunisia",
    flag: "🇹🇳",
    format: "XX XXX XXX",
    example: "20 123 456",
    maxLength: 11
  },
  {
    code: "+90",
    name: "Turkey",
    flag: "🇹🇷",
    format: "XXX XXX XXXX",
    example: "532 123 4567",
    maxLength: 13
  },
  {
    code: "+993",
    name: "Turkmenistan",
    flag: "🇹🇲",
    format: "XX XXXXXX",
    example: "65 123456",
    maxLength: 11
  },
  {
    code: "+688",
    name: "Tuvalu",
    flag: "🇹🇻",
    format: "XXXXX",
    example: "90123",
    maxLength: 8
  },
  {
    code: "+256",
    name: "Uganda",
    flag: "🇺🇬",
    format: "XXX XXX XXX",
    example: "712 345 678",
    maxLength: 12
  },
  {
    code: "+380",
    name: "Ukraine",
    flag: "🇺🇦",
    format: "XX XXX XXXX",
    example: "50 123 4567",
    maxLength: 12
  },
  {
    code: "+971",
    name: "United Arab Emirates",
    flag: "🇦🇪",
    format: "XX XXX XXXX",
    example: "50 123 4567",
    maxLength: 12
  },
  {
    code: "+44",
    name: "United Kingdom",
    flag: "🇬🇧",
    format: "XXXX XXX XXXX",
    example: "7123 456 789",
    maxLength: 13
  },
  {
    code: "+1",
    name: "United States",
    flag: "🇺🇸",
    format: "(XXX) XXX-XXXX",
    example: "(555) 123-4567",
    maxLength: 14
  },
  {
    code: "+598",
    name: "Uruguay",
    flag: "🇺🇾",
    format: "XXXX XXXX",
    example: "9123 4567",
    maxLength: 11
  },
  {
    code: "+998",
    name: "Uzbekistan",
    flag: "🇺🇿",
    format: "XX XXX XXXX",
    example: "90 123 4567",
    maxLength: 12
  },
  {
    code: "+678",
    name: "Vanuatu",
    flag: "🇻🇺",
    format: "XXX XXXX",
    example: "591 2345",
    maxLength: 10
  },
  {
    code: "+379",
    name: "Vatican City",
    flag: "🇻🇦",
    format: "XX XX XX XX",
    example: "06 69 88 17",
    maxLength: 11
  },
  {
    code: "+58",
    name: "Venezuela",
    flag: "🇻🇪",
    format: "XXX XXX XXXX",
    example: "412 123 4567",
    maxLength: 13
  },
  {
    code: "+84",
    name: "Vietnam",
    flag: "🇻🇳",
    format: "XXX XXX XXXX",
    example: "912 345 678",
    maxLength: 12
  },
  {
    code: "+967",
    name: "Yemen",
    flag: "🇾🇪",
    format: "XXX XXX XXX",
    example: "712 345 678",
    maxLength: 12
  },
  {
    code: "+260",
    name: "Zambia",
    flag: "🇿🇲",
    format: "XXX XXX XXX",
    example: "977 123 456",
    maxLength: 12
  },
  {
    code: "+263",
    name: "Zimbabwe",
    flag: "🇿🇼",
    format: "XX XXX XXXX",
    example: "71 123 4567",
    maxLength: 12
  }
];

/**
 * Clean phone number by removing all non-digit characters except +
 */
export function cleanPhoneNumber(phone: string): string {
  return phone.replace(/[^\d+]/g, "");
}

/**
 * Detect country from phone number
 */
export function detectCountry(phone: string): CountryCode | null {
  const cleaned = cleanPhoneNumber(phone);
  
  // Sort by code length (longer first) to match more specific codes first
  const sortedCodes = [...COUNTRY_CODES].sort((a, b) => b.code.length - a.code.length);
  
  for (const country of sortedCodes) {
    if (cleaned.startsWith(country.code)) {
      return country;
    }
  }
  
  return null;
}

/**
 * Format phone number based on detected country
 */
export function formatPhoneNumber(phone: string, country?: CountryCode | null): string {
  const cleaned = cleanPhoneNumber(phone);
  
  if (!cleaned) return "";
  
  // Auto-detect country if not provided
  const detectedCountry = country || detectCountry(cleaned);
  
  if (!detectedCountry) {
    // Return cleaned number if no country detected
    return cleaned;
  }
  
  // Remove country code for formatting
  let numberPart = cleaned;
  if (cleaned.startsWith(detectedCountry.code)) {
    numberPart = cleaned.slice(detectedCountry.code.length);
  }
  
  // Only format if number part is not empty and has some digits
  if (!numberPart.replace(/\D/g, '')) {
    return detectedCountry.code + (numberPart ? " " + numberPart : "");
  }
  
  // Format based on country
  switch (detectedCountry.code) {
    case "+39": // Italy format
      return formatItalianNumber(numberPart, detectedCountry.code);
    case "+1": // US/Canada format
      return formatUSNumber(numberPart, detectedCountry.code);
    case "+44": // UK format
      return formatUKNumber(numberPart, detectedCountry.code);
    case "+33": // France format
      return formatFrenchNumber(numberPart, detectedCountry.code);
    case "+49": // Germany format
      return formatGermanNumber(numberPart, detectedCountry.code);
    case "+34": // Spain format
      return formatSpanishNumber(numberPart, detectedCountry.code);
    default:
      return formatGenericNumber(numberPart, detectedCountry.code);
  }
}

/**
 * Format US/Canada phone number: +1 (555) 123-4567
 */
function formatUSNumber(number: string, countryCode: string): string {
  const digits = number.replace(/\D/g, "");
  
  if (digits.length === 0) return countryCode + " ";
  if (digits.length <= 3) return `${countryCode} (${digits}`;
  if (digits.length <= 6) return `${countryCode} (${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `${countryCode} (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

/**
 * Format UK phone number: +44 7123 456 789
 */
function formatUKNumber(number: string, countryCode: string): string {
  const digits = number.replace(/\D/g, "");
  
  if (digits.length === 0) return countryCode + " ";
  if (digits.length <= 4) return `${countryCode} ${digits}`;
  if (digits.length <= 7) return `${countryCode} ${digits.slice(0, 4)} ${digits.slice(4)}`;
  return `${countryCode} ${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7, 10)}`;
}

/**
 * Format French phone number: +33 6 12 34 56 78
 */
function formatFrenchNumber(number: string, countryCode: string): string {
  const digits = number.replace(/\D/g, "");
  
  if (digits.length === 0) return countryCode + " ";
  if (digits.length <= 1) return `${countryCode} ${digits}`;
  if (digits.length <= 3) return `${countryCode} ${digits.slice(0, 1)} ${digits.slice(1)}`;
  if (digits.length <= 5) return `${countryCode} ${digits.slice(0, 1)} ${digits.slice(1, 3)} ${digits.slice(3)}`;
  if (digits.length <= 7) return `${countryCode} ${digits.slice(0, 1)} ${digits.slice(1, 3)} ${digits.slice(3, 5)} ${digits.slice(5)}`;
  return `${countryCode} ${digits.slice(0, 1)} ${digits.slice(1, 3)} ${digits.slice(3, 5)} ${digits.slice(5, 7)} ${digits.slice(7, 9)}`;
}

/**
 * Format Italian phone number: +39 312 345 6789
 */
function formatItalianNumber(number: string, countryCode: string): string {
  const digits = number.replace(/\D/g, "");
  
  if (digits.length === 0) return countryCode + " ";
  if (digits.length <= 3) return `${countryCode} ${digits}`;
  if (digits.length <= 6) return `${countryCode} ${digits.slice(0, 3)} ${digits.slice(3)}`;
  return `${countryCode} ${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 10)}`;
}

/**
 * Format German phone number: +49 151 1234567
 */
function formatGermanNumber(number: string, countryCode: string): string {
  const digits = number.replace(/\D/g, "");
  
  if (digits.length === 0) return countryCode + " ";
  if (digits.length <= 3) return `${countryCode} ${digits}`;
  return `${countryCode} ${digits.slice(0, 3)} ${digits.slice(3)}`;
}

/**
 * Format Spanish phone number: +34 612 345 678
 */
function formatSpanishNumber(number: string, countryCode: string): string {
  const digits = number.replace(/\D/g, "");
  
  if (digits.length === 0) return countryCode + " ";
  if (digits.length <= 3) return `${countryCode} ${digits}`;
  if (digits.length <= 6) return `${countryCode} ${digits.slice(0, 3)} ${digits.slice(3)}`;
  return `${countryCode} ${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 9)}`;
}

/**
 * Format generic international phone number
 */
function formatGenericNumber(number: string, countryCode: string): string {
  const digits = number.replace(/\D/g, "");
  
  if (digits.length === 0) return countryCode + " ";
  
  // Generic formatting: group digits in chunks of 3-4
  const chunks = [];
  let remaining = digits;
  
  while (remaining.length > 0) {
    if (remaining.length > 4) {
      chunks.push(remaining.slice(0, 3));
      remaining = remaining.slice(3);
    } else {
      chunks.push(remaining);
      break;
    }
  }
  
  return `${countryCode} ${chunks.join(' ')}`;
}

/**
 * Validate phone number format
 */
export function validatePhoneNumber(phone: string): {
  isValid: boolean;
  message: string;
  country?: CountryCode;
} {
  const cleaned = cleanPhoneNumber(phone);
  
  if (!cleaned) {
    return { isValid: false, message: "Phone number is required" };
  }
  
  // Must start with + for international format
  if (!cleaned.startsWith("+")) {
    return { isValid: false, message: "Please include country code (e.g., +1)" };
  }
  
  const country = detectCountry(cleaned);
  
  if (!country) {
    return { isValid: false, message: "Unsupported country code" };
  }
  
  // Remove country code for length validation
  const numberPart = cleaned.slice(country.code.length);
  
  // Basic length validation
  if (numberPart.length < 7) {
    return { isValid: false, message: "Phone number is too short" };
  }
  
  if (numberPart.length > 15) {
    return { isValid: false, message: "Phone number is too long" };
  }
  
  // Country-specific validation
  switch (country.code) {
    case "+39": // Italy
      if (numberPart.length !== 10) {
        return { isValid: false, message: "Italian numbers must be 10 digits" };
      }
      break;
    case "+1": // US/Canada
      if (numberPart.length !== 10) {
        return { isValid: false, message: "US/Canada numbers must be 10 digits" };
      }
      break;
    case "+44": // UK
      if (numberPart.length < 10 || numberPart.length > 11) {
        return { isValid: false, message: "UK numbers must be 10-11 digits" };
      }
      break;
    case "+34": // Spain
      if (numberPart.length !== 9) {
        return { isValid: false, message: "Spanish numbers must be 9 digits" };
      }
      break;
  }
  
  return { isValid: true, message: "", country };
}

/**
 * Get cursor position after formatting
 */
export function getCursorPosition(oldValue: string, newValue: string, oldCursor: number): number {
  // Count non-digit characters before cursor in old value
  const oldPrefix = oldValue.slice(0, oldCursor);
  const digitsBeforeCursor = oldPrefix.replace(/[^\d]/g, "").length;
  
  // Find position in new value that has same number of digits
  let digitCount = 0;
  for (let i = 0; i < newValue.length; i++) {
    if (/\d/.test(newValue[i])) {
      digitCount++;
      if (digitCount === digitsBeforeCursor) {
        return i + 1;
      }
    }
  }
  
  return newValue.length;
}